function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.8,10.47A3.87,3.87,0,0,1,10.1,9L15,13.91a3.7,3.7,0,0,1-1.48.31A3.75,3.75,0,0,1,9.8,10.47ZM18.13,13A5.21,5.21,0,0,0,11,5.89L12.14,7a3.69,3.69,0,0,1,1.41-.28,3.75,3.75,0,0,1,3.75,3.75A3.69,3.69,0,0,1,17,11.88ZM13.55,1.52a19.19,19.19,0,0,0-6,.93L8.77,3.63A18.67,18.67,0,0,1,13.55,3C20.19,3,25.6,6.36,25.6,10.47c0,2.28-1.67,4.33-4.3,5.69l1.08,1.08c2.89-1.64,4.72-4.06,4.72-6.77C27.1,5.53,21,1.52,13.55,1.52ZM3,0l-1,1,2.7,2.71C1.86,5.31,0,7.75,0,10.47c0,4.93,6.08,9,13.55,9a19.3,19.3,0,0,0,6-1L23.07,22,24,21ZM13.55,17.92c-6.64,0-12-3.34-12-7.45,0-2.3,1.7-4.36,4.35-5.73L9,7.89A5.22,5.22,0,0,0,16.13,15l2.27,2.27A18.77,18.77,0,0,1,13.55,17.92Z"
});

var SvgHide = function SvgHide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.1,
    height: 21.95,
    viewBox: "0 0 27.1 21.95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hide.70e9522e.svg";
export { ForwardRef as ReactComponent };